import { render, staticRenderFns } from "./CourseThumbBox.vue?vue&type=template&id=163b22e6&scoped=true"
import script from "./CourseThumbBox.vue?vue&type=script&lang=js"
export * from "./CourseThumbBox.vue?vue&type=script&lang=js"
import style0 from "./CourseThumbBox.vue?vue&type=style&index=0&id=163b22e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b22e6",
  null
  
)

export default component.exports